import { gql } from '@apollo/client';
import { AccountDeliveryDriverType } from '../../types/AccountDeliveryDriverType';

export const GET_CENTRAL_DELIVERY_DRIVER_LISTING = gql`
    query GetCentralDeliveryDriverListing($filter: AccountDeliveryDriverFiltersTypeInput, $pageRequest: PageRequestTypeInput) {
        getCentralDeliveryDriverListing(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                accountId
                dspId
                driverLicenseNumber
                vehicleTypeId
                vehiclePlate
                isOnDuty
                isBlacklist
                isEmployed
                vehicleImageS3KeysJson
                vehicleImageUrls
                verificationStatus
                verificationTime
                reviewComment
                idDocumentType
                idDocumentNumber
                idDocumentImageS3KeysJson
                idDocumentImageUrls
                createdAt
                updatedAt
                account {
                    id
                    name
                    countryCode
                    phone
                    email
                    status
                    phoneStatus
                }
                dsp {
                    id
                    name
                    dspCode
                }
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface CentralDeliveryDriverListingResponse {
    getCentralDeliveryDriverListing: {
        content: AccountDeliveryDriverType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}
